import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { OneWayInServicesService } from 'src/api/v2';
import { ONE_WAY_IN_SERVICE, ONE_WAY_IN_SERVICE_DELETE, ONE_WAY_IN_SERVICES } from 'src/constants/hook-keys';

const useOneWayInService = (serviceId: string) => {
  const [oneWayInServicesService] = useState(new OneWayInServicesService());

  const queryClient = useQueryClient();

  const { data, ...rest } = useQuery({
    queryKey: [ONE_WAY_IN_SERVICE, serviceId],
    queryFn: () => oneWayInServicesService.getOneWayInService(serviceId),
    enabled: !!serviceId,
    retry: false,
    staleTime: 1000 * 60 * 30, // 30 min refetching on mount
    refetchOnMount: true,
    keepPreviousData: false,
  });

  const deleteQuery = useMutation({
    mutationKey: [ONE_WAY_IN_SERVICE_DELETE, serviceId],
    mutationFn: () => oneWayInServicesService.delete(serviceId),
    onSuccess() {
      // Invalidate the query for the service list
      queryClient.invalidateQueries([ONE_WAY_IN_SERVICES]);
      queryClient.invalidateQueries([ONE_WAY_IN_SERVICE, serviceId]);
    },
  });

  return {
    service: data,
    ...rest,
    queries: {
      delete: deleteQuery,
    },
  };
};

export default useOneWayInService;
